import * as z from "zod";

export const manuallyConvertChatToEmail = {
  name: "manuallyConvertChatToEmail" as const,
  input: z.object({
    conversationId: z.string(),
    customerEmail: z
      .string()
      .min(1, { message: "Required field" })
      .email("Invalid email"),
  }),
  output: z.object({}),
};
